var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProjectStagesBro(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M466,255.68c-7.79,41.36-30.17,88.54-69.73,108.2-59.78,29.7-58.53,81.81-172.23,96.6a230.91,230.91,0,0,1-50,1.27,190.56,190.56,0,0,1-24.27-3.67C79.15,442.76,34.59,389.92,21.11,328.89c-17.74-80.25,32-128.56,64.83-157.48S147.83,47.36,259.49,32a223.64,223.64,0,0,1,51.45-1.34c39.1,3.66,80.93,19.46,108.64,48.33q3.12,3.25,6.05,6.71C463.82,130.65,476.63,199.29,466,255.68Z",
    style: {
      fill: "#E94560"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466,255.68c-7.79,41.36-30.17,88.54-69.73,108.2-59.78,29.7-58.53,81.81-172.23,96.6a230.91,230.91,0,0,1-50,1.27,190.56,190.56,0,0,1-24.27-3.67C79.15,442.76,34.59,389.92,21.11,328.89c-17.74-80.25,32-128.56,64.83-157.48S147.83,47.36,259.49,32a223.64,223.64,0,0,1,51.45-1.34c39.1,3.66,80.93,19.46,108.64,48.33q3.12,3.25,6.05,6.71C463.82,130.65,476.63,199.29,466,255.68Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M362,217.24c.29-.91-.37-2.68-.61-3.21-1.24-2.76-4.3-4-7.2-3.77a8.35,8.35,0,0,1-3.15,0,5.13,5.13,0,0,1-2.73-2.73,26.26,26.26,0,0,0-4.29-6c-2.61-2.72-6.14-4.72-10-4.59-10.43.36-9.36,9-12.24,11.52-1.6,1.4-2.75-.6-4.11-1.28a4.77,4.77,0,0,0-5.38.57c-1.49,1.25-2.37,3.07-3.54,4.63s-2.93,3-4.87,2.75c-1.62-.17-2.91-1.43-4.46-1.95A6.68,6.68,0,0,0,294,214a14.26,14.26,0,0,0-3.62,3.27Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.78,106.12c.45-1.39-.56-4.1-.93-4.92-1.9-4.23-6.6-6.15-11.05-5.78-1.62.13-3.28.51-4.83,0-1.94-.6-3.25-2.39-4.2-4.19A40.23,40.23,0,0,0,436.19,82c-4-4.18-9.42-7.25-15.38-7-16,.56-14.36,13.81-18.78,17.68-2.46,2.16-4.23-.91-6.32-2a7.3,7.3,0,0,0-8.25.87c-2.29,1.93-3.64,4.72-5.44,7.11s-4.49,4.55-7.47,4.22c-2.49-.27-4.47-2.19-6.85-3a10.27,10.27,0,0,0-8.27,1.21,22.27,22.27,0,0,0-5.56,5Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.22,59.23c.29-.92-.37-2.68-.61-3.21-1.24-2.76-4.3-4-7.2-3.77a8.35,8.35,0,0,1-3.15,0,5.13,5.13,0,0,1-2.73-2.73,26.26,26.26,0,0,0-4.29-6c-2.61-2.72-6.14-4.72-10-4.59-10.43.36-9.36,9-12.24,11.52-1.6,1.4-2.75-.6-4.11-1.28a4.77,4.77,0,0,0-5.38.57C77,51,76.12,52.81,75,54.37s-2.93,3-4.87,2.75c-1.62-.18-2.91-1.43-4.46-1.95a6.65,6.65,0,0,0-5.39.79,14.26,14.26,0,0,0-3.62,3.27Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Smoke--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M445.15,431.36a11,11,0,0,0,1.11-4.82,10.62,10.62,0,0,0-10.36-10.85,9.93,9.93,0,0,0-5.31,1.55,9.82,9.82,0,0,0,.14-1.55,8.63,8.63,0,1,0-17.24-.57l-.6,0A19.31,19.31,0,0,0,402.77,418a20.82,20.82,0,0,0-12-9.32,9.41,9.41,0,0,0,4.88-8.33,8.92,8.92,0,1,0-17.83,0,9.43,9.43,0,0,0,4.09,7.85,19.9,19.9,0,0,0-6.18,2.15,16.47,16.47,0,0,0-15.46-11.51,15.87,15.87,0,0,0-10.72,4.2c-1.4-12.78-11.76-22.72-24.34-22.72a23.94,23.94,0,0,0-18.2,8.5c-4.16-12.08-15.19-20.72-28.15-20.72A28.8,28.8,0,0,0,262.76,373a17.77,17.77,0,0,0-16.12,1.42A17.77,17.77,0,0,0,230.52,373a28.8,28.8,0,0,0-16.08-4.92c-13,0-24,8.64-28.15,20.72a24,24,0,0,0-18.21-8.5c-12.58,0-22.94,9.94-24.33,22.72a15.89,15.89,0,0,0-10.72-4.2,16.46,16.46,0,0,0-15.46,11.51,20.08,20.08,0,0,0-6.18-2.15,9.43,9.43,0,0,0,4.09-7.85,8.92,8.92,0,1,0-17.83,0,9.39,9.39,0,0,0,4.88,8.33,20.82,20.82,0,0,0-12,9.32,19.34,19.34,0,0,0-10.12-2.88c-.21,0-.4,0-.61,0a8.62,8.62,0,1,0-17.09,2.12,9.94,9.94,0,0,0-5.32-1.55A10.61,10.61,0,0,0,47,426.54a11,11,0,0,0,1.11,4.82Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Platform--inject-9"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 322.54,
    y: 79.85,
    width: 19.99,
    height: 350.06,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 322.53,
    y1: 184.09,
    x2: 307.17,
    y2: 184.09,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 322.53,
    y1: 276.94,
    x2: 302.57,
    y2: 276.94,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "342.53 79.85 323.28 104.29 342.31 104.29 322.54 79.85",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "342.53 104.9 323.28 129.33 342.31 129.33 322.54 104.9",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "342.53 129.94 323.28 154.38 342.31 154.38 322.54 129.94",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "342.53 154.99 323.28 179.42 342.31 179.42 322.54 154.99",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "342.53 180.03 323.28 204.46 342.31 204.46 322.54 180.03 307.21 180.03",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "342.53 205.07 323.28 229.5 342.31 229.5 322.54 205.07",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "342.53 230.12 323.28 254.55 342.31 254.55 322.54 230.12",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "342.53 255.16 323.28 279.59 342.31 279.59 322.54 255.16",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "342.53 280.2 323.28 304.64 342.31 304.64 322.54 280.2 302.6 280.2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "342.53 305.25 323.28 329.68 342.31 329.68 322.54 305.25",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "342.53 330.29 323.28 354.72 342.31 354.72 322.54 330.29",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "342.53 355.33 323.28 379.77 342.31 379.77 322.54 355.33",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "342.53 380.38 323.28 404.81 342.31 404.81 322.54 380.38",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "342.53 405.42 323.28 429.85 342.31 429.85 322.54 405.42",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "342.13 430.56 150.36 430.56 177.76 400.94 314.73 400.94 342.13 430.56",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 187.43,
    cy: 416.39,
    r: 7.54,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 217.58,
    cy: 416.39,
    r: 7.54,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.73,
    cy: 416.39,
    r: 7.54,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.88,
    cy: 416.39,
    r: 7.54,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 308.03,
    cy: 416.39,
    r: 7.54,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.93,
    y: 429.94,
    width: 442.62,
    height: 12.91,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Rocket--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M307.56,167.55l-10,219.24H194.83l-10-219.24c0-29.9,12.51-57.25,26.1-78.53,12.41-19.43,25.72-33.8,31.24-40.48a4.69,4.69,0,0,1,7.19,0C255,55.18,268.51,69.57,281.09,89,294.88,110.3,307.56,137.64,307.56,167.55Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 300.09,
    y1: 190.12,
    x2: 291.75,
    y2: 378.86,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.56,103.41c10.18,18,18.66,39.77,19.38,63.27",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.09,89H210.93c12.41-19.43,25.72-33.8,31.24-40.48a4.69,4.69,0,0,1,7.19,0C255,55.18,268.51,69.57,281.09,89Z",
    style: {
      fill: "#E94560",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.68,275.11s-26.06,9-35.86,33.47c-7.68,19.21-9.71,56.15-10.23,71.15a6.36,6.36,0,0,0,6.36,6.58h0a6.34,6.34,0,0,0,5.59-3.33c5.1-9.46,21-35.88,37.58-31.86Z",
    style: {
      fill: "#E94560",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.74,274.89s26.14,9.2,35.93,33.69c7.69,19.21,9.72,56.15,10.23,71.15a6.36,6.36,0,0,1-6.36,6.58h0A6.34,6.34,0,0,1,337,383c-5.1-9.46-21.19-35.73-37.78-31.71Z",
    style: {
      fill: "#E94560",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310,278.27a59.29,59.29,0,0,0-7.29-3.38l-3.57,76.38a14.76,14.76,0,0,1,5.24-.3Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.51,
    y: 386.63,
    width: 84.63,
    height: 15.01,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--icon-4--inject-9"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 245.33,
    cy: 328.22,
    r: 22.81,
    transform: "translate(-70.04 66.58) rotate(-13.54)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.33,
    cy: 328.22,
    r: 17.96,
    transform: "translate(-68.37 64.58) rotate(-13.18)",
    style: {
      fill: "#E94560",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.33,
    cy: 328.22,
    r: 14.76,
    transform: "translate(-68.46 64.68) rotate(-13.2)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.33,
    cy: 328.22,
    r: 10.75,
    transform: "translate(-68.56 64.8) rotate(-13.22)",
    style: {
      fill: "#E94560",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.33,
    cy: 328.22,
    r: 6.79,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.47,328.22a3.15,3.15,0,1,0-3.14,3.14A3.14,3.14,0,0,0,248.47,328.22Z",
    style: {
      fill: "#E94560",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "246.62 323.29 245.33 328.22 249.98 329.24 246.62 323.29",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 248.61,
    y1: 326.04,
    x2: 269.04,
    y2: 314.91,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "262.48 318.57 262.79 313.23 272.39 307.74 272.39 313.84 262.48 318.57",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "276.51 316.74 272.3 313.63 262.44 318.82 267.19 321.57 276.51 316.74",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--icon-3--inject-9"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 245.33,
    cy: 262.08,
    r: 22.81,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.68,
    y: 258.88,
    width: 6.86,
    height: 13.87,
    style: {
      fill: "#E94560",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.96,
    y: 254.47,
    width: 6.86,
    height: 18.28,
    style: {
      fill: "#E94560",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.24,
    y: 250.37,
    width: 6.86,
    height: 22.38,
    style: {
      fill: "#E94560",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--icon-2--inject-9"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 245.33,
    cy: 197.57,
    r: 22.81,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.86,200.67v-5.92h-3.93a12.56,12.56,0,0,0-1.56-3.84l2.84-2.85L255,183.88l-2.83,2.83a12.49,12.49,0,0,0-3.78-1.57V181h-5.91v4.11a12.31,12.31,0,0,0-3.7,1.53l-3-3-4.18,4.19,3,3a12.85,12.85,0,0,0-1.54,3.63h-4.28v5.92H233a12.58,12.58,0,0,0,1.46,3.66l-3,3,4.18,4.18,2.94-2.93a12.85,12.85,0,0,0,3.67,1.61v4.18h5.91v-4a12.77,12.77,0,0,0,3.81-1.49l2.88,2.87,4.18-4.18-2.79-2.8a12.65,12.65,0,0,0,1.64-3.8Zm-16.39,3.64a6.75,6.75,0,1,1,6.74-6.74A6.75,6.75,0,0,1,245.47,204.31Z",
    style: {
      fill: "#E94560",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--icon-1--inject-9"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 245.33,
    cy: 133.06,
    r: 22.81,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.12,127.86a12,12,0,0,0-23.94-.51,11.85,11.85,0,0,0,2.49,7.82,13.58,13.58,0,0,1,3,8.26v.64h13v-.64a13.18,13.18,0,0,1,2.91-8.17A11.86,11.86,0,0,0,257.12,127.86Z",
    style: {
      fill: "#E94560",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.7,
    y: 146.17,
    width: 9.01,
    height: 6.34,
    rx: 1.9,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.65,
    y: 144.07,
    width: 13.08,
    height: 2.97,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "250.41 150.25 239.95 150.25 238.65 147.27 251.72 147.27 250.41 150.25",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--stage-4--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.49,286.36A3,3,0,0,1,67,286a2,2,0,0,1-.9-1,4.42,4.42,0,0,1-.36-1.7l1.71-.29a4.58,4.58,0,0,0,.12,1,1.31,1.31,0,0,0,.31.6.75.75,0,0,0,.53.19.55.55,0,0,0,.52-.24,1.1,1.1,0,0,0,.14-.55,1.72,1.72,0,0,0-.3-1,4.83,4.83,0,0,0-.77-.83l-1-.87a4.13,4.13,0,0,1-.88-1,2.68,2.68,0,0,1-.34-1.41,2.38,2.38,0,0,1,.7-1.85,2.78,2.78,0,0,1,1.92-.64,2.61,2.61,0,0,1,1.2.24,1.78,1.78,0,0,1,.73.65,2.67,2.67,0,0,1,.36.87,6.24,6.24,0,0,1,.13.94l-1.7.26a7.51,7.51,0,0,0-.07-.78,1.08,1.08,0,0,0-.22-.53.6.6,0,0,0-.49-.19.56.56,0,0,0-.51.25,1.08,1.08,0,0,0-.17.57,1.47,1.47,0,0,0,.23.85,4.06,4.06,0,0,0,.65.69l1,.86a5.75,5.75,0,0,1,1,1.21,3,3,0,0,1,.44,1.67,2.56,2.56,0,0,1-.31,1.24,2.18,2.18,0,0,1-.87.86A2.66,2.66,0,0,1,68.49,286.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.94,286.22V278h-1.5V276.5h5V278H74.94v8.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.46,286.22l1.88-9.72h2.2l1.87,9.72H80.58l-.35-2.13H78.69l-.37,2.13Zm2.41-3.34H80L79.45,279Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.75,286.37a2.58,2.58,0,0,1-1.56-.42,2.15,2.15,0,0,1-.82-1.17,5.6,5.6,0,0,1-.25-1.77v-3.25a5.63,5.63,0,0,1,.25-1.8,2.14,2.14,0,0,1,.88-1.17,3.13,3.13,0,0,1,1.71-.41,3.32,3.32,0,0,1,1.65.35,1.91,1.91,0,0,1,.87,1,3.81,3.81,0,0,1,.27,1.51v.56H86.82v-.68a4.5,4.5,0,0,0,0-.68.8.8,0,0,0-.22-.46.81.81,0,0,0-.56-.17.75.75,0,0,0-.58.2,1.08,1.08,0,0,0-.23.52,5,5,0,0,0,0,.68v4.31a3.23,3.23,0,0,0,.07.73,1,1,0,0,0,.27.51,1,1,0,0,0,1.14,0,1.09,1.09,0,0,0,.29-.53,3.42,3.42,0,0,0,.07-.75v-1H86v-1.2h2.73v5H87.48l-.12-.87a1.8,1.8,0,0,1-.58.73A1.7,1.7,0,0,1,85.75,286.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.13,286.22V276.5h4.23v1.37H92.11v2.58h1.74v1.38H92.11v3.05h2.28v1.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.94,286.22V284H98V282.5l2.53-6h2.16v6h.94V284h-.94v2.26Zm-1.49-3.68h1.49v-4.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 65.36,
    y1: 295.17,
    x2: 114.12,
    y2: 295.17,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 65.36,
    y1: 301.96,
    x2: 114.12,
    y2: 301.96,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 65.36,
    y1: 308.74,
    x2: 114.12,
    y2: 308.74,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 65.36,
    y1: 315.52,
    x2: 114.12,
    y2: 315.52,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "222.52 327.75 164.32 327.75 164.32 281.1 113.08 281.1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--stage-3--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.49,224.25a3.08,3.08,0,0,1-1.5-.33,2.07,2.07,0,0,1-.9-1,4.47,4.47,0,0,1-.36-1.7l1.71-.29a4.48,4.48,0,0,0,.12,1,1.21,1.21,0,0,0,.31.6.76.76,0,0,0,.53.2.55.55,0,0,0,.52-.24,1.1,1.1,0,0,0,.14-.55,1.72,1.72,0,0,0-.3-1,4.83,4.83,0,0,0-.77-.83l-1-.88a4.08,4.08,0,0,1-.88-1,2.72,2.72,0,0,1-.34-1.42,2.36,2.36,0,0,1,.7-1.84,2.73,2.73,0,0,1,1.92-.64,2.61,2.61,0,0,1,1.2.24,1.76,1.76,0,0,1,.73.64,2.72,2.72,0,0,1,.36.88,6.07,6.07,0,0,1,.13.94l-1.7.25c0-.29,0-.55-.07-.78a1.12,1.12,0,0,0-.22-.53.63.63,0,0,0-.49-.19.57.57,0,0,0-.51.26,1,1,0,0,0-.17.57,1.49,1.49,0,0,0,.23.85,4.06,4.06,0,0,0,.65.69l1,.86a5.29,5.29,0,0,1,1,1.21,3,3,0,0,1,.44,1.67,2.56,2.56,0,0,1-.31,1.24,2.32,2.32,0,0,1-.87.86A2.66,2.66,0,0,1,68.49,224.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.94,224.12v-8.24h-1.5V214.4h5v1.48H74.94v8.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.46,224.12l1.88-9.72h2.2l1.87,9.72H80.58L80.23,222H78.69l-.37,2.14Zm2.41-3.35H80l-.59-3.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.75,224.26a2.58,2.58,0,0,1-1.56-.41,2.21,2.21,0,0,1-.82-1.18,5.52,5.52,0,0,1-.25-1.77v-3.25a5.71,5.71,0,0,1,.25-1.8,2.15,2.15,0,0,1,.88-1.16,3.13,3.13,0,0,1,1.71-.41,3.32,3.32,0,0,1,1.65.35,1.93,1.93,0,0,1,.87,1,3.88,3.88,0,0,1,.27,1.51v.57H86.82V217a4.36,4.36,0,0,0,0-.67.86.86,0,0,0-.22-.47.81.81,0,0,0-.56-.16.72.72,0,0,0-.58.2,1.08,1.08,0,0,0-.23.52,4.88,4.88,0,0,0,0,.68v4.31a3.29,3.29,0,0,0,.07.73.93.93,0,0,0,.27.5.81.81,0,0,0,.57.18.77.77,0,0,0,.57-.19,1,1,0,0,0,.29-.52,3.42,3.42,0,0,0,.07-.75v-1H86v-1.2h2.73v5H87.48l-.12-.88a1.83,1.83,0,0,1-.58.74A1.7,1.7,0,0,1,85.75,224.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.13,224.12V214.4h4.23v1.37H92.11v2.58h1.74v1.38H92.11v3.05h2.28v1.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.72,224.29a2.79,2.79,0,0,1-1.54-.37,2.05,2.05,0,0,1-.82-1,4.23,4.23,0,0,1-.25-1.53V221H100v.33a4,4,0,0,0,.07.77.91.91,0,0,0,.24.46.65.65,0,0,0,.48.16.69.69,0,0,0,.48-.16,1,1,0,0,0,.21-.48,4.15,4.15,0,0,0,.06-.77,2.5,2.5,0,0,0-.21-1.13.9.9,0,0,0-.87-.41h-.32v-1.37h.29a1,1,0,0,0,.88-.35,2,2,0,0,0,.23-1.09,2,2,0,0,0-.16-.9.65.65,0,0,0-.63-.33.59.59,0,0,0-.6.36,2.66,2.66,0,0,0-.15.93v.43H98.11v-.53a3,3,0,0,1,.31-1.44,2.11,2.11,0,0,1,.89-.91,2.87,2.87,0,0,1,1.4-.31,3.1,3.1,0,0,1,1.42.3,2,2,0,0,1,.89.87,3,3,0,0,1,.31,1.43,2.6,2.6,0,0,1-.36,1.42,1.58,1.58,0,0,1-.87.72,1.63,1.63,0,0,1,.64.39,2,2,0,0,1,.43.74,3.47,3.47,0,0,1,.16,1.15,4.62,4.62,0,0,1-.25,1.55,2.15,2.15,0,0,1-.83,1.06A2.69,2.69,0,0,1,100.72,224.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 65.36,
    y1: 233.07,
    x2: 114.12,
    y2: 233.07,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 65.36,
    y1: 239.85,
    x2: 114.12,
    y2: 239.85,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 65.36,
    y1: 246.64,
    x2: 114.12,
    y2: 246.64,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 65.36,
    y1: 253.42,
    x2: 114.12,
    y2: 253.42,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "222.52 263.57 164.32 263.57 164.32 216.91 113.08 216.91",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--stage-2--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.49,162.15a3.08,3.08,0,0,1-1.5-.33,2.05,2.05,0,0,1-.9-1,4.41,4.41,0,0,1-.36-1.69l1.71-.29a4.48,4.48,0,0,0,.12,1,1.21,1.21,0,0,0,.31.6.76.76,0,0,0,.53.2.55.55,0,0,0,.52-.24,1.12,1.12,0,0,0,.14-.55,1.72,1.72,0,0,0-.3-1A4.49,4.49,0,0,0,68,158l-1-.88a4.08,4.08,0,0,1-.88-1,2.74,2.74,0,0,1-.34-1.42,2.36,2.36,0,0,1,.7-1.84,2.73,2.73,0,0,1,1.92-.64,2.61,2.61,0,0,1,1.2.24,1.76,1.76,0,0,1,.73.64,2.72,2.72,0,0,1,.36.88,6.07,6.07,0,0,1,.13.94l-1.7.25a7.51,7.51,0,0,0-.07-.78,1.12,1.12,0,0,0-.22-.53.6.6,0,0,0-.49-.19.57.57,0,0,0-.51.26,1,1,0,0,0-.17.57,1.46,1.46,0,0,0,.23.84,4.06,4.06,0,0,0,.65.69l1,.87a5.46,5.46,0,0,1,1,1.2,3.07,3.07,0,0,1,.44,1.68,2.52,2.52,0,0,1-.31,1.23,2.27,2.27,0,0,1-.87.87A2.66,2.66,0,0,1,68.49,162.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.94,162v-8.25h-1.5V152.3h5v1.47H74.94V162Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.46,162l1.88-9.72h2.2L82.41,162H80.58l-.35-2.14H78.69L78.32,162Zm2.41-3.35H80l-.59-3.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.75,162.16a2.65,2.65,0,0,1-1.56-.41,2.21,2.21,0,0,1-.82-1.18,5.6,5.6,0,0,1-.25-1.77v-3.25a5.63,5.63,0,0,1,.25-1.8,2.15,2.15,0,0,1,.88-1.16,3,3,0,0,1,1.71-.41,3.21,3.21,0,0,1,1.65.35,1.93,1.93,0,0,1,.87,1,3.84,3.84,0,0,1,.27,1.51v.57H86.82v-.69a4.61,4.61,0,0,0,0-.68.83.83,0,0,0-.22-.46.81.81,0,0,0-.56-.17.72.72,0,0,0-.58.21,1,1,0,0,0-.23.52,4.88,4.88,0,0,0,0,.68v4.31a3.29,3.29,0,0,0,.07.73,1,1,0,0,0,.27.5.81.81,0,0,0,.57.18.77.77,0,0,0,.57-.19,1.06,1.06,0,0,0,.29-.52,3.42,3.42,0,0,0,.07-.75v-1H86V157h2.73v5H87.48l-.12-.88a1.73,1.73,0,0,1-.58.73A1.64,1.64,0,0,1,85.75,162.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.13,162V152.3h4.23v1.37H92.11v2.58h1.74v1.38H92.11v3h2.28V162Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.14,162v-1.31l2.37-3.64.5-.78a4.49,4.49,0,0,0,.38-.76,2.31,2.31,0,0,0,.15-.83,1.24,1.24,0,0,0-.18-.72.61.61,0,0,0-.52-.24.7.7,0,0,0-.55.2,1,1,0,0,0-.26.52,3.11,3.11,0,0,0-.07.71v.45H98.14v-.48a4.05,4.05,0,0,1,.27-1.53,2.18,2.18,0,0,1,.86-1.05,2.67,2.67,0,0,1,1.53-.38,2.56,2.56,0,0,1,1.93.67,2.62,2.62,0,0,1,.65,1.88,3.16,3.16,0,0,1-.18,1.09,4.78,4.78,0,0,1-.48,1c-.19.31-.4.63-.63.95l-1.87,2.82h2.89V162Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 65.36,
    y1: 170.97,
    x2: 114.12,
    y2: 170.97,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 65.36,
    y1: 177.75,
    x2: 114.12,
    y2: 177.75,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 65.36,
    y1: 184.53,
    x2: 114.12,
    y2: 184.53,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 65.36,
    y1: 191.32,
    x2: 114.12,
    y2: 191.32,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "222.52 199.39 164.32 199.39 164.32 152.73 113.08 152.73",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--stage-1--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.49,89a3.08,3.08,0,0,1-1.5-.33,2.07,2.07,0,0,1-.9-1,4.47,4.47,0,0,1-.36-1.7l1.71-.29a4.48,4.48,0,0,0,.12,1,1.21,1.21,0,0,0,.31.6.76.76,0,0,0,.53.2.55.55,0,0,0,.52-.24,1.1,1.1,0,0,0,.14-.55,1.72,1.72,0,0,0-.3-1,4.83,4.83,0,0,0-.77-.83L67,84a4.08,4.08,0,0,1-.88-1,2.72,2.72,0,0,1-.34-1.42,2.36,2.36,0,0,1,.7-1.84A2.73,2.73,0,0,1,68.38,79a2.61,2.61,0,0,1,1.2.24,1.76,1.76,0,0,1,.73.64,2.72,2.72,0,0,1,.36.88,6.07,6.07,0,0,1,.13.94L69.1,82c0-.29,0-.55-.07-.78a1.12,1.12,0,0,0-.22-.53.63.63,0,0,0-.49-.19.57.57,0,0,0-.51.26,1,1,0,0,0-.17.57,1.49,1.49,0,0,0,.23.85,4.06,4.06,0,0,0,.65.69l1,.86a5.29,5.29,0,0,1,1,1.21A3,3,0,0,1,71,86.58a2.56,2.56,0,0,1-.31,1.24,2.32,2.32,0,0,1-.87.86A2.66,2.66,0,0,1,68.49,89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.94,88.86V80.62h-1.5V79.14h5v1.48H74.94v8.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.46,88.86l1.88-9.72h2.2l1.87,9.72H80.58l-.35-2.14H78.69l-.37,2.14Zm2.41-3.35H80l-.59-3.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.75,89a2.58,2.58,0,0,1-1.56-.41,2.21,2.21,0,0,1-.82-1.18,5.52,5.52,0,0,1-.25-1.77V82.39a5.71,5.71,0,0,1,.25-1.8,2.15,2.15,0,0,1,.88-1.16A3.13,3.13,0,0,1,86,79a3.32,3.32,0,0,1,1.65.35,1.93,1.93,0,0,1,.87,1,3.88,3.88,0,0,1,.27,1.51v.57H86.82v-.69a4.36,4.36,0,0,0,0-.67.86.86,0,0,0-.22-.47.81.81,0,0,0-.56-.16.72.72,0,0,0-.58.2,1.08,1.08,0,0,0-.23.52,4.88,4.88,0,0,0,0,.68v4.31a3.29,3.29,0,0,0,.07.73.93.93,0,0,0,.27.5.81.81,0,0,0,.57.18.77.77,0,0,0,.57-.19,1.06,1.06,0,0,0,.29-.52A3.42,3.42,0,0,0,87,86.1v-1H86v-1.2h2.73v5H87.48L87.36,88a1.83,1.83,0,0,1-.58.74A1.7,1.7,0,0,1,85.75,89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.13,88.86V79.14h4.23v1.37H92.11v2.58h1.74v1.38H92.11v3h2.28v1.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.34,88.86v-7.8l-.29.13-.4.14-.41.14-.3.12V80.22l.39-.19.52-.27a3.76,3.76,0,0,0,.52-.31,1.86,1.86,0,0,0,.38-.31h1.44v9.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 65.36,
    y1: 97.81,
    x2: 114.12,
    y2: 97.81,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 65.36,
    y1: 104.59,
    x2: 114.12,
    y2: 104.59,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 65.36,
    y1: 111.38,
    x2: 114.12,
    y2: 111.38,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 65.36,
    y1: 118.16,
    x2: 114.12,
    y2: 118.16,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "222.52 133.06 164.32 133.06 164.32 84.25 113.08 84.25",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412.54,465.13a20,20,0,0,1-4.48,5.92c-2.72,2.24-7.68,5.93-8.8,6.89s-1,1.92,2.88,3,9.44,1.12,12.32,0,5.61-1,7.05-1.6,2.24-1.28,2.4-2.88S422.63,465,422.63,465Z",
    style: {
      fill: "#E94560",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.89,475.36a40.44,40.44,0,0,0-5.58,2.1c-4.65,2.08-5.45,2.72-11.21,2.72a11.34,11.34,0,0,1-7.49-2.53l-.35.29c-1.12,1-1,1.92,2.88,3s9.44,1.12,12.32,0,5.61-1,7.05-1.6,2.24-1.28,2.4-2.88A9.29,9.29,0,0,0,423.89,475.36Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.27,466.89s-2.88,9-4.16,11.21-4.16,4.48-4,6.08,3,2.08,8,2.08,8.33-1,9.77-3.52,1.6-3.2,2.4-4.8-.48-11.21-.48-11.21S432.71,467.05,431.27,466.89Z",
    style: {
      fill: "#E94560",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.88,482.74c1.44-2.56,1.6-3.2,2.4-4.8a8.91,8.91,0,0,0,.24-3.17c-.59,1-1.26,2.28-2,3.65-1.92,3.52-3,5.12-9.61,5.44a25.81,25.81,0,0,1-8.57-.71,2,2,0,0,0-.23,1c.16,1.6,3,2.08,8,2.08S439.44,485.3,440.88,482.74Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398,355.64s-.8,15.85-.16,28,7.36,35.22,7.36,35.22,3.2,19.53,4.16,25.13,3,18.25,3,18.25l10.89-.64V443.2c0-3.36-.48-24.49-.48-24.49s5.6,28.81,6.08,32,1.6,12.65,1.6,12.65a24.83,24.83,0,0,0,5.6,1.12c2.08,0,7.21-1.44,7.21-1.44s1.92-19.21,1.76-25-2.72-14.41-3.52-17-3.21-10.08-3-10.72,1.93-21.77,1.93-26.1V372.77l-3.37-17-1.44-2.56s-18.73,3.2-27.21,1-10.72-2.88-10.72-2.88Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.5,377.09l5.92,4.48s3.53,24.17,5.61,31.7",
    style: {
      fill: "none",
      stroke: "#949494",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.62,457.61s5.76-.16,9.77-.16,4.64.16,4.64,1.12.48,6.72,0,7.36-5.12.64-7.52.64-5.61.48-5.93-1a37.21,37.21,0,0,0-.8-4.48C410.3,459.85,409.66,458.73,410.62,457.61Z",
    style: {
      fill: "#707070",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429,458.73a6.34,6.34,0,0,0-.32,2.4,49.16,49.16,0,0,1,.48,5.44c0,1.44-.32,1.12,3,2.24s10.57,0,11.37-1,.8-6.08.8-7.2-.32-1.6-1.44-1.28-6.89,1.28-9,.8a21.4,21.4,0,0,1-3.52-1.12S429.35,457.77,429,458.73Z",
    style: {
      fill: "#707070",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.63,285.69l-6.08-3.2-15.21,4.16s-4.32,7.52-5.12,13.93-1.92,38.73-1.92,44.66-.32,10.4-.32,10.4,4,2.88,11,3.2a78.9,78.9,0,0,0,13.13-.32c1.6-.16,6.88-3.2,6.88-3.2s-1-30.41-1-34.74,3-24.81,3.68-27.69S430.63,285.69,430.63,285.69Z",
    style: {
      fill: "#707070",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.44,288.54c1.12,3.07-.93,6.63-4.57,8s-7.5-.08-8.62-3.15.93-6.63,4.57-8S420.32,285.47,421.44,288.54Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.86,290.65s5.93,6.56,6.41,6.24,9.12-12.16,9.12-12.16l-2.24-3.68Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.38,283.45a18.16,18.16,0,0,1-1.76,3c-.8,1-2.88,8.32-2.88,8.32l5.12-4.16s.32-4.64.48-5.76A1.33,1.33,0,0,0,412.38,283.45Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.42,275.12a18.21,18.21,0,0,1,1,3.37c0,.8-.64,12.64.48,12.16s12.81-8.32,13.29-9.6-.32-9,0-10.89,1-4.8,1-4.8-4.64,4.8-8.32,6.88A29.72,29.72,0,0,1,411.42,275.12Z",
    style: {
      fill: "#b5b5b5",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.38,278.49c0,.39-.15,3.43-.18,6.38l10.57-10.8-11.21,1.44A14.11,14.11,0,0,1,412.38,278.49Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.24,336.27l3.2-11.68s1-15.55,2.62-22.21a21.91,21.91,0,0,1,5.7-10.29c-.8-1.44-10.72-4.16-13.77-5.28S427.27,283,427.27,283s-5.44,20.65-5.76,29.45-.8,14.25.48,22.73-5.59,28.7-2.23,33.83,10.19,5,13.32,5.66c6,1.33,14.16-2.21,14.32-3.33s-2.68-7-5.08-17.27A72.59,72.59,0,0,1,440.24,336.27Z",
    style: {
      fill: "#E94560",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "437.95 353.15 424.5 351.51 423.84 355.78 438.28 358.41",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.27,292.83a8,8,0,0,0-4.8,3.11c-1.7,2.54-15,36.73-15.26,38.71s1.41,5.08,4,6.21,3.39,3.39,4.24,2,9.33-13,9.33-13l3.67-32.77Z",
    style: {
      fill: "#E94560",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.71,323.91s-7.91,9.89-8.2,12.15-.56,4.8.57,6.5,6.21,2.82,8.19,2,5.65-11.3,5.65-11.3Z",
    style: {
      fill: "#E94560",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.9,284.09a81.86,81.86,0,0,0-4.64,13.44,166.36,166.36,0,0,0-3,26.42c-.16,7.68-1.28,39.85-1.44,42.58s-2.24,4.16-5.28,4.8a21,21,0,0,1-6.73,0s3.36-22.89,3.52-26.57.16-9.13.16-12.17S393,314,392.88,310.35s2.91-16.72,3.39-17.52,8.75-4.1,9.39-4.58S410.14,285.37,411.9,284.09Z",
    style: {
      fill: "#E94560",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "394.29 354.47 399.87 353.81 400.86 350.86 394.95 351.51",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.87,337.55c-.16,2.88-.16,4.48-.16,4.48",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.11,291.07c.05,5.4.12,13.19.12,13.19L426.31,307l3.52,6.24s-2.93,13.09-4.29,20.19",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.07,286c0,.12,0,1.4,0,3.23",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.21,331.29c-1.32-7.75-3.55-20.47-3.55-20.47l5.28-5.6-3.68-2.88s1.12-2.24,2.08-4,5.12-9.28,5.12-9.28",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402,336c-.1-.65-.25-1.55-.43-2.63",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.16,256.33c-.5,0-6.74.4-7.07-4.66a5.9,5.9,0,0,1,4.1-6.27s-3.9-4.28,1.12-6.63,11-1.12,11-1.12-.58-3.9,4.05-2.75,7.79,6.39,7.92,6.9,6.54,2.62,8.67,5.95,1.5,7.64-.2,10.55a77.21,77.21,0,0,1-5.36,7.36,4.2,4.2,0,0,1-4.23.56c-2.45-1-4.07-1.78-3.94-3.79s-.51-7.41-1.14-8.12-2.11-1-5.17-.35S406.16,256.33,406.16,256.33Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.09,254.82a45.69,45.69,0,0,1-.73,6,132,132,0,0,0-2.27,13.94c-.2,3,3,5.4,4.66,5.51s4.46-1.38,7-1.88,9.41-2.9,10.53-4.5,1.48-2.08,1.48-2.08,5.26-1,6.05-5.3-2-4.84-4.1-3.8a16.24,16.24,0,0,0-3.16,2s-1.5-.1-1.25-1.26a13.59,13.59,0,0,0,.47-2.15c.06-.83-.41-1.37-.95-3.25s-.89-1.73-.12-3.36,2.32-4.54,2.32-4.54S411.57,250.66,406.09,254.82Z",
    style: {
      fill: "#b5b5b5",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.11,255.93a7,7,0,0,1,4.1.76",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.81,255.65a3.15,3.15,0,0,0-2.6-.09",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.08,270.15s2.11,1.15,4.92-.85",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.35,259.29a1,1,0,0,1-1.06.94,1,1,0,1,1,.13-2A1,1,0,0,1,415.35,259.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408,258.3a.84.84,0,1,1-.78-.89A.83.83,0,0,1,408,258.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.43,258.54s-6.62,5.29-6.08,7.17,6.09,1.75,6.09,1.75",
    style: {
      fill: "#b5b5b5",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.1,314.3l3.67-3.39s4.24,2,4,4S386.1,314.3,386.1,314.3Z",
    style: {
      fill: "#b5b5b5",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.39,315.88l3.68-3.39s4.24,2,3.95,4S384.39,315.88,384.39,315.88Z",
    style: {
      fill: "#b5b5b5",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.33,314.86s.36-3,1.7-3,2.55.85,2.19,2.43a17.92,17.92,0,0,1-1.22,3.29Z",
    style: {
      fill: "#b5b5b5",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.77,310.91s0-1.41,3.11-.56,4.8,4.24,3.95,5.65-3.1-1.13-3.1-1.13S392.6,311.76,389.77,310.91Z",
    style: {
      fill: "#b5b5b5",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "374.19 313.64 387.84 344.28 412.48 346.27 400.83 314.97 374.19 313.64",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.73,289.5s-5.18,2.06-6.19,5.71,0,38.31,0,38.31l-23.45-1.13-.85,10.73,28.86,7.35s4.2.9,6.26-1.8,4.91-41,5.26-45.09.64-9.92-2.9-11.81A15.31,15.31,0,0,0,445.73,289.5Z",
    style: {
      fill: "#E94560",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.5,333.52s4.36.92,6.66,2.89",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.05,332.39s-1.13.56-4.24-1.7a13.12,13.12,0,0,0-5.65-2.54l.56,3.11s-9.32,1.13-10.17,2-1.69,3.11.57,4,2.82,0,3.67,1.41a14.36,14.36,0,0,0,5.65,4.24c1.7.56,9-2.26,9-2.26Z",
    style: {
      fill: "#b5b5b5",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectStagesBro);
export default __webpack_public_path__ + "static/media/Project Stages-bro.97c18b17fcbf6ca5c4b956811ac009b8.svg";
export { ForwardRef as ReactComponent };